<template>

  <el-collapse-item name="标题" title="标题">

    <el-form-item label="开启">
      <el-switch v-model="ele.option.title.show" active-color="#55aaff"
                 inactive-color="#ff557f"></el-switch>
    </el-form-item>

    <el-form-item label="文本">
      <el-input v-model="ele.option.title.text"></el-input>
    </el-form-item>
    <el-form-item label="字体大小">
      <el-input v-model="ele.option.title.textStyle.fontSize"></el-input>
    </el-form-item>

    <el-form-item label="文本颜色">
      <el-color-picker v-model="ele.option.title.textStyle.color"
                       :predefine="['rgba(255, 255, 255, 1.0)','#ff4500',  '#ff8c00',  '#ffd700', '#90ee90',  '#00ced1', '#1e90ff',  '#c71585',  'rgba(255, 69, 0, 0.68)',  'rgb(255, 120, 0)',  'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)','#c7158577']"
                       show-alpha>
      </el-color-picker>
    </el-form-item>


    <el-form-item label="距离左侧距离">
      <template #label>
        左侧距离
        <el-tooltip effect="dark" placement="bottom-start">
          <template #content>
            图例组件离容器左侧的距离 <br/>可以是像 20 这样的具体像素值<br/>
            可以是像 '20%' 这样相对于容器高宽的百分比<br/>
            也可以是 'left', 'center', 'right'
          </template>
          <el-button icon="el-icon-s-help" text></el-button>
        </el-tooltip>
      </template>
      <el-input v-model="ele.option.title.left"></el-input>
    </el-form-item>
    <el-form-item label="超链接">
      <el-input v-model="ele.option.title.link"></el-input>
    </el-form-item>

  </el-collapse-item>

</template>


<script>
export default {

  props: {
    element: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },

}

</script>

<style scoped lang="scss">

</style>